<template>
    <section class="fac-modal scroll-color" :visible="visible" :class="[{'open': status, local, inline}, {'fullscreen' : fullscreen}, {'loading' : load}]" :style="$mx_zindex" @click.self="closeOnOverlayHandler">
        <div v-show="load && !customLoader" class="modal-load-indicator" >
            <span v-if="loadSuccess" class="modal-load-icon">
                <i class="fal fa-check-circle"/>
            </span>
            <span v-else-if="loadFail" class="modal-load-icon-fail">
                <i class="fal fa-times icon"/>
            </span>
            <ui-load-indicator v-else bg-color="#e7e9f4" color="#69D296" :h="50" :stroke="8"/>
        </div>

        <div v-show="load && customLoader" class="modal-custom-load-indicator">
            <slot name="custom-loader"/>
        </div>

        <div v-show="!load" class="fac-modal-container">
            <div v-if="hasLeftContainer" class="fac-modal-content-left">
                <slot name="left"/>
            </div>

            <div class="fac-modal-content" :class="computedClassModalContent">
                <div v-if="imageComputed" class="box-top-center box-image">
                    <ui-image :src="imageComputed" alt="Modal message image" design="circle border-xl" h="90" w="90" />
                </div>

                <div v-if="iconCircle" :class="colorCircle" class="box-top-center box-icon-circle">
                    <i v-if="icon" class="icon-circle" :class="icon"/>
                </div>

                <section v-else-if="title || icon && !iconCircle" class="header">
                    <div v-if="title" class="header-title">
                        <i v-if="icon" class="icon" :class="icon"/>
                        <div class="header-content">
                            <div class="header-title">
                                <div class="title" :class="colorTitle">{{title}}<span :class="colorConcat">{{concatTitle}}</span></div>
                                <div v-if="caution" class="caution">{{caution}}</div>
                            </div>
                            <div class="header-slot">
                                <slot name="header"/>
                            </div>
                        </div>
                    </div>

                    <div v-if="!title">
                        <slot name="title"/>
                    </div>

                    <button
						v-if="showCloseOption"
						type="button"
						@click="closeHandle"
						:data-ui="dataUiCancelButton || null">
                        	<i class="fal fa-times"/>
                    </button>
                </section>

                <section class="body" :class="computedClassBody">
                    <slot/>
                </section>

                <section v-if="hasFooter" class="footer" :style="{ background: footerBackground}">
                    <slot name="footer"/>
                </section>

                <div v-if="load" class="loading">
                    <div/>
                </div>
            </div>

            <div v-if="hasRightContainer" class="fac-modal-content-right">
                <slot name="right"/>
            </div>
        </div>
    </section>
</template>

<script>
	import { uiImage, uiLoadIndicator } from '@/components/ui'
	import { modalMixin } from '@/mixins'

	export default {
		name: 'ui-modal',

		components: {
			uiLoadIndicator,
			uiImage,
		},

		mixins: [modalMixin],

		props: {
			title: {
				type: String,
				required: false,
				default: ''
			},
			concatTitle: {
				type: String,
				required: false,
				default: ''
			},
			colorConcat: {
				type: String,
				required: false,
				default: 'concat-success'
			},
			colorTitle: {
				type: String,
				required: false,
				default: 'concat-success'
			},
			caution: {
				type: String,
				required: false,
				default: ''
			},
			icon: {
				type: String,
				required: false,
				default: ''
			},
			name: {
				type: String,
				required: true,
				default: ''
			},
			visible: {
				type: Boolean,
				default: false,
			},
			size: {
				type: String,
				required: false,
				default: ''
			},
			load: {
				type: Boolean,
				default: false,
				required: false
			},
			colorCircle: {
				type: String,
				default: 'primary',
				required: false
			},
			iconCircle: {
				type: Boolean,
				default: false,
				required: false
			},
			loadSuccess: {
				type: Boolean,
				default: false,
				required: false
			},
			loadFail: {
				type: Boolean,
				default: false,
				required: false
			},
			local: {
				type: Boolean,
				default: false,
				required: false
			},
			inline: {
				type: Boolean,
				default: false,
				required: false
			},
			fullscreen: {
				type: Boolean,
				default: false,
				required: false
			},
			closeOnOverlay: {
				type: Boolean,
				default: false,
				required: false
			},
			closeable: {
				type: Boolean,
				default: true,
				required: false
			},
			aboveAll: {
				type: Boolean,
				default: false,
				required: false
			},
			/**
			 * Usado para mostrar uma imagem no topo do modal
			 */
			image: {
				type: String,
				required: false,
				default: '',
			},
			showCloseOption: {
				type: Boolean,
				default: true,
				required: false
			},

			// Propriedades de Estilos
			brlOff: {
				type: Boolean,
				default: false,
			},

			customLoader:{
				type: Boolean,
				default: false,
			},

			brrOff: {
				type: Boolean,
				default: false,
			},
			/**
			 * Define uma tag de teste para os testes integrados do botao de cancelar
			 */
			 dataUiCancelButton: {
				type: String,
				required: false,
				default: ''
			},
			footerBackground: {
				type: String,
				default: '#F5F7FE'
			}
		},

		data() {
			return {
				status: false,
			}
		},

		computed: {
			hasFooter() {
				return !!this.$slots.footer
			},

			hasLeftContainer() {
				return !!this.$slots.left
			},

			hasRightContainer() {
				return !!this.$slots.right
			},
			/** Computed property para retornar a imagem configurada no data ou no prop */
			imageComputed() {
				return this.data && this.data.image ? this.data.image : this.image
			},

			computedClassModalContent(){
				return {
					'has-image': this.image,
					'has-icon-circle': this.iconCircle,
					'brl-off': this.brlOff,
					'brr-off': this.brrOff,
					[this.size]: this.size
				}
			},

			computedClassBody(){
				return {
					'radius-bottom': !this.hasFooter
				}
			},
		},

		created() {
			document.addEventListener('keydown', (event) => {
				if(event.key === "Escape") {
					this.close()
					this.$root.$emit('pause-video')
				}
			});
		},

		mounted() {
			this.$root.$on("modal-open-" + this.name, () => {
				this.open()
			})

			this.$root.$on("modal-close-" + this.name, () => {
				this.close()
			})

			this.$root.$on("modal-toggle-" + this.name, () => {
				this.toggle()
			})
		},

		beforeDestroy() {
			this.$root.$off("modal-open-" + this.name)
			this.$root.$off("modal-close-" + this.name)
			this.$root.$off("modal-toggle-" + this.name)
		},

		methods: {
			close() {
				// Remove o modal da lista de modais
				this.$mx_removeModal(this.name)
				this.status = false
			},

			open() {
				// Adiciona o modal na lista de modais
				this.$mx_setModal({
					name: this.name,
					visible: true,
				})
				this.status = true
			},

			toggle() {
				this.status = !this.status
			},

			closeHandle() {
				this.$root.$emit('modal-close-' + this.name)
				this.$emit('close')
			},

			closeOnOverlayHandler() {
				if(this.closeOnOverlay) {
					this.closeHandle()
				}
			}
		}
	};
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>